// extracted by mini-css-extract-plugin
var _1 = "t2f";
var _2 = "t2e";
var _3 = "t2a";
var _4 = "t2h";
var _5 = "t2d";
var _6 = "t2c";
var _7 = "t2b";
export { _1 as "button", _2 as "code", _3 as "container", _4 as "footer", _5 as "message", _6 as "text", _7 as "title" }
